import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { Teacher } from '../teacher.js';

export const editTeacherMutation = registerMutation({
  operationName: 'editTeacherMutation',
  type: () => Boolean,
  params: [
    { name: 'firstName', type: () => String },
    { name: 'lastName', type: () => String },
    { name: 'school', type: () => String },
    { name: 'subjects', type: () => [String] },
  ],
  resolve: (firstName: string, lastName: string, school: string, subjects: string[]) => async () => {
    const sessionData = await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 });

    if (!sessionData?.userID) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const teacherCollection = await getCollection(Teacher);

    const result = await teacherCollection.updateOne(
      { userID: sessionData.userID },
      {
        $set: {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          school: school.trim(),
          subjects,
        },
      },
    );

    return result.matchedCount > 0;
  },
});
